import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'

// Redux
import { useDispatch } from 'react-redux'
import { fetchCategoriesStart } from '../../store/categories/categories.action'

// Component
import CategoriesPreview from '../categories-preview/categories-preview.component'
import Category from '../category/category.component'

import './shop.styles.scss'

const Shop = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCategoriesStart())
  }, [])

  return (
    <Routes>
      <Route index element={<CategoriesPreview />} />
      <Route path=":category" element={<Category />} />
    </Routes>
  )
}

export default Shop
